import { render, staticRenderFns } from "./ManagementSidebar.vue?vue&type=template&id=6211379d&scoped=true"
import script from "./ManagementSidebar.vue?vue&type=script&lang=ts"
export * from "./ManagementSidebar.vue?vue&type=script&lang=ts"
import style0 from "./ManagementSidebar.vue?vue&type=style&index=0&id=6211379d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6211379d",
  null
  
)

export default component.exports